// Module
var code = `<div class="page-item--cta-banner">
  <h2 class="cta-banner-headline">{{headline}}</h2>
  <p class="cta-banner-text">{{text}}</p>
  <a
    class="cta-banner-btn btn btn-primary"
    data-channel="ROUTE"
    data-event-prevent-default="true"
    data-page-id="{{attrPageId}}"
    data-end-route="true"
    href="{{attrCtaHref}}"
    >{{ctaText}}</a
  >
</div>
`;
// Exports
module.exports = code;